export enum MemberStatusEnum {


    ENABLED = -1,
    DISABLED = 0,
    AWAITING_ACCEPTANCE = 1,
    REJECTED = 2,
    DISABLED_BY_APPLICATION = 3,
    AWAITING_ACTIVATION = 4,
    UNDER_PREPARATION = 5,
    DISABLED_BAD_EMAIL = 6,
    DISABLED_HIMSELF = 7,
    SPAM_ROBOT = 9,

}